import type { CohesionWindow } from '../adapters/tagular/types';

/**
 * Browser window shape used by eventing without augmenting the global `Window`
 * (hen-site supplies `TagularFn` from @redventures/cohesion-utils-react).
 */
export type BrowserWindowWithCohesion = Window & {
  tagular?: (
    method: 'beam',
    event: Record<string, unknown>,
    ...rest: unknown[]
  ) => void;
  _Cohesion?: CohesionWindow;
};

export function getBrowserWindow(): BrowserWindowWithCohesion | undefined {
  if (typeof globalThis.window === 'undefined') {
    return undefined;
  }
  return globalThis.window as BrowserWindowWithCohesion;
}
